export const environment = {
    production: true,
    apiUrl: 'https://api.coursesignage.com/api',
    contentEndpoint: 'https://api.coursesignage.com/',
    stripeKey: 'pk_live_51Oi5xBC3Esw99YfYx07obKllM9jqpPEIPtWtaSZHS6gBzJeNJydRLKnO91wMHlfxW7WfBYaSMA7ueyjWtabR84b500HkicUjEU' // Inject via CI/CD — do NOT commit a real key here
  };